import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { CountryData, Areas } from '../../_models/country';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrl: './areas.component.css'
})
export class AreasComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  formHeader: string = "Add New Area";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Area";

  countryRef: number;
  countryData: CountryData;

  edit: boolean = false;

  areaName: string = '';
  areaRef: number = 0;

  dataForm = this.fb.group({
    ref: [0],
    state: ["", Validators.required],
    country: ["", Validators.required],
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get state() { return this.dataForm.get('state'); }
  get country() { return this.dataForm.get('country'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.countryData = new CountryData();
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['id'] !== undefined) {
      this.countryRef = this.routeParams['id'];
    }
    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getCountry();
  }

  getCountry() {
    this.loading = true;

    this.apiService.getCountry(this.countryRef).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.countryData = data.data;

          this.dataForm.patchValue({
            country: this.countryData.iso
          });
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      state: this.dataForm.value.state,
      country: this.dataForm.value.country,
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editCountryArea(data);
    } else {
      this.createCountryArea(data);
    }
  }

  createCountryArea( data ) {
    this.processing = true;

    this.buttonText = "Adding New Area...";
    this.apiService.createCountryArea(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.state+" as an area in "+this.countryData.title, "Area Created");
          this.checkService.closeModal('modal-area-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Area";
      }
    );
  }

  editCountryArea( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
    this.apiService.editCountryArea(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to area in "+this.countryData.title, "Area Edited");
          this.checkService.closeModal('modal-area-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Area";
        this.edit = false;
      }
    );
  }

  getEdit(data:Areas) {
    this.dataForm.patchValue({
      ref: data.ref,
      state: data.state,
    });
    this.edit = true;
    this.formHeader = "Edit "+data.state;
    this.buttonText = "Edit Area";
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset();
    this.formHeader = this.buttonText = "Add New Area";
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });
  }

  deleteArea(ref:number) {
    this.processing = true;

    this.apiService.deleteArea(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Area Removed Successfully", "Area Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.areaName = name;
    this.areaRef = ref;
  }
}
